import { Component } from "@angular/core";

@Component({
  selector: "app-exception-handling",
  // imports: [],
  templateUrl: "./exception-handling.component.html",
  styleUrl: "./exception-handling.component.css",
  standalone: false,
})
export class ExceptionHandlingComponent {
  selectedTabIndex = 0;
}
